const initiatePrisliste = (wrapper) => {
  const renderTableVisibility = () => {
    let showItemPricing = false;
    let showCallPricing = false;

    jQuery(".price-main-object.price-table .price-item", wrapper).hide();

    const tjenester = [];
    jQuery("[type=radio]:checked,[type=checkbox]:checked", wrapper).each(
      (idx, el) => {
        tjenester.push(jQuery(el).val());
      }
    );

    jQuery(
      ".nav-button-link [type=radio],.nav-button-link [type=checkbox]",
      wrapper
    )
      .unbind("click")
      .bind("click", (e) => {
        window.location = jQuery(e.currentTarget).data("link");
        e.preventDefault();
      });

    jQuery(".price-item", wrapper).each((idx, el) => {
      if (tjenester.includes(jQuery(el).data("tjenestetype"))) {
        jQuery(el).show();
        const viewcode = jQuery(el).data("viewcode");
        showItemPricing = showItemPricing || `${viewcode}`[0] === "1";
        showCallPricing = showCallPricing || `${viewcode}`[1] === "1";
      }
    });

    if (showItemPricing) {
      jQuery(".price-table", wrapper).addClass("view-price-items");
    } else {
      jQuery(".price-table", wrapper).removeClass("view-price-items");
    }

    if (showCallPricing) {
      jQuery(".price-table", wrapper).addClass("view-price-calls ");
    } else {
      jQuery(".price-table", wrapper).removeClass("view-price-calls ");
    }
  };

  jQuery("[type=radio],[type=checkbox]", wrapper)
    .off("change")
    .on("change", function() {
        // Add 'active' class to closest parent with class 'nav-button'
        const $parentNavButton = jQuery(this).closest(".nav-button");
        const $genPrisSubtext = jQuery(".generelle-priser-subtext");
        $parentNavButton.addClass("active");

        // Remove 'active' class from siblings of the parent nav-button
        $parentNavButton.siblings(".nav-button").removeClass("active");

        // Check if the parent has class 'utland'
        if ($parentNavButton.hasClass("utland")) {
            // Determine if it has 'i-utland' or 'til-utland'
            const utlandType = $parentNavButton.hasClass("i-utland") ? "i-utland" : "til-utland";

            // Find all elements with class 'price-main-object'
            const $priceMainObjects = jQuery(".price-main-object");

            // Remove 'visible' class from all price-main-object elements
            $priceMainObjects.removeClass("visible");
            $genPrisSubtext.hide();

            // Add 'visible' class to the price-main-object that matches the utlandType
            const $visiblePriceMainObject = $priceMainObjects.filter(`.${utlandType}`);
            $visiblePriceMainObject.addClass("visible");

            // Target all .price-item children of the visible price-main-object and remove inline display: none
            $visiblePriceMainObject.find(".price-item").css("display", ""); // Removes inline display style
        } else {
            // Find all elements with class 'price-main-object'
            const $priceMainObjects = jQuery(".price-main-object");

            // Remove 'visible' class from all price-main-object elements
            $priceMainObjects.removeClass("visible");

            // Add 'visible' class to the price-main-object that also has class 'price-table'
            $priceMainObjects.filter(".price-table").addClass("visible");
            $genPrisSubtext.show();
        }

        renderTableVisibility(); // Call the original handler
    });

  renderTableVisibility();
};

const initiatePrislisteUtland = (wrapper) => {
  jQuery(".price-item-group", wrapper)
    .off("click") // Modern jQuery syntax
    .on("click", (e) => {
      const $currentTarget = jQuery(e.currentTarget);

      // Check if the clicked element already has the 'caption-open' class
      if ($currentTarget.hasClass("caption-open")) {
        // If it's already open, close it by removing the class
        $currentTarget.removeClass("caption-open");
      } else {
        // If it's not open, close all others and open the clicked one
        jQuery(".price-item-group", wrapper).removeClass("caption-open");
        $currentTarget.addClass("caption-open");
      }
    });
};

export const initiateGlobalPrisliste = () =>
  jQuery(".unifon-global-prisliste").each((idx, element) =>
    initiatePrisliste(element)
  );
jQuery(".unifon-prisliste-utland").each((idx, element) =>
  initiatePrislisteUtland(element)
);
